import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import { isNumber } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import CurrencyIcon from '@swf/components/CurrencyIcon/CurrencyIcon';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import type { Dispatch } from '@swf/core/store';
import { isZeroExponentCurrency } from '@swf/first';

import { TXTWCL_Preferred } from './BalanceRecordItem.messages.json';
import { active, amount, arrow, main, preferredLabel, record } from './BalanceRecordItem.scss';

interface Props {
  balance?: number;
  currency?: Currency;
  expand?: boolean;
  info?: React.ReactNode;
  isHeader?: boolean;
  label?: React.ReactNode;
  preferred?: boolean;
  className?: string;
  isInstantBonus?: boolean;
}

const BalanceRecordItem: React.FC<Props> = ({
  balance,
  currency,
  expand = false,
  info = false,
  isHeader = false,
  preferred = false,
  label,
  className,
  isInstantBonus = false
}) => {
  const { modal } = useDispatch<Dispatch>();
  const currencyAmount = isNumber(balance) && currency && (
    <CurrencyAmount
      value={balance / 100}
      isZeroExponentCurrency={isZeroExponentCurrency(currency)}
      currency={currency}
      style="decimal"
      dollarValue
    />
  );

  return (
    <div className={classNames(record, className, { [main]: isHeader })}>
      <div>{isHeader && currency && <CurrencyIcon currency={currency} />}</div>
      <div>
        {label || currency}
        {info}
      </div>
      <div className={classNames({ [preferredLabel]: isHeader && preferred })}>
        {isHeader && preferred && <Translation {...TXTWCL_Preferred} />}
      </div>
      {currencyAmount && (
        <div className={amount}>
          {isInstantBonus ? (
            <StarsLink
              onClick={() => {
                modal.enqueue({ path: '/account/my-stars/bonus/instant-bonuses' });
              }}
            >
              {currencyAmount}
            </StarsLink>
          ) : (
            currencyAmount
          )}
        </div>
      )}
      <div>{isHeader && <Arrow className={classNames(arrow, { [active]: expand })} />}</div>
    </div>
  );
};
export default BalanceRecordItem;
